import { AppContext } from "store/context/AppContext"
import PublicContext from "store/context/PublicContext"
import { useContext } from "react"
import cn from "classnames"
import { HiOutlineMenu } from "react-icons/hi";           // replaces GiHamburgerMenu
import { FiUser } from "react-icons/fi";                  // replaces FaUserCircle
import { FiBell } from "react-icons/fi";                  // replaces FaBell
import { HiOutlineLogout } from "react-icons/hi";         // replaces TbLogout
import { MdOutlineModeEdit } from "react-icons/md";       // replaces MdModeEditOutline

import logo_omnix_white from "assets/img/logo_omnix_white.svg"
import { Popover } from "components/Core"
import useLogin from "hooks/useLogin"
import usePreRender from "hooks/usePreRender"

interface IHeader {
  className?: string
}

const Header = ({ className }: IHeader) => {
  const { _color } = usePreRender()
  const { user: current_user } = useContext(PublicContext)
  const { open_sidebar, set_open_sidebar } = useContext(AppContext)
  const { logout_user_action } = useLogin()

  const handle_sidebar = () => set_open_sidebar(!open_sidebar)

  return (
    <div
      color="primary"
      className={cn(
        "w-full h-auto flex flex-row items-center justify-between py-4 px-6",
        // `bg-[${_color}]`,
        `bg_${_color}`,
        className,
      )}
    >
      <div
        className={cn("flex flex-row justify-center items-center gap-6 lg:gap-10")}
      >
        <HiOutlineMenu onClick={handle_sidebar} className="text-2xl text-white cursor-pointer" />
        <a href="/dashboard">
          <img src={logo_omnix_white} alt="logo" className="cursor-pointer" />
        </a>        
      </div>
      <div className="flex flex-row gap-6">
        <Popover
          content={
            <div className="w-52 text-center">
              <p>Omnix - XMonitor</p>
            </div>
          }
        >
          <span></span>
          <FiBell className="text-2xl text-white cursor-pointer" />
        </Popover>
        <span className="border-l-2 border-l-white"></span>
        <Popover
          content={
            <div className="w-72 h-auto flex flex-col justify-center items-center gap-4 py-3 px-6">
              <div className="w-full flex flex-col gap-1 text-left pb-2">
                <h4 className="text-xl font-semibold text-black capitalize">{current_user?.name}</h4>
                <p className="text-sm text-[#A9A9A9]">Perfil: {current_user?.role}</p>
                <p className="text-sm text-[#A9A9A9]">userName: {current_user?.custom?.userName}</p>
                <p className="text-sm text-[#A9A9A9]">jobPosition: {current_user?.custom?.jobPosition}</p>
                <p className="text-sm text-[#A9A9A9]">marketSegment: {current_user?.custom?.marketSegment}</p>
              </div>
              <div className="w-full flex flex-col gap-1 items-start justify-center">
                <a
                  href="/"
                  className={cn("flex flex-row items-center justify-start gap-2 text-black", `hover:text_${_color}`)}
                >
                  <MdOutlineModeEdit className="text-lg" />
                  <p className="text-md">Editar Perfil</p>
                </a>
                <button
                  onClick={logout_user_action}
                  className={cn("flex flex-row items-center justify-start gap-2 text-black", `hover:text_${_color}`)}
                >
                  <HiOutlineLogout className="text-lg" />
                  <p className="text-md">Cerrar Sesión</p>
                </button>
              </div>
            </div>
          }
        >
          <span></span>
          <FiUser className="text-2xl text-white cursor-pointer" />
        </Popover>
      </div>
    </div>
  )
}

export default Header
